import type { Distance } from "@pdfking/math"
import { Scale, Subtract, Total } from "@pdfking/math"
import { HorizontalAlign } from "@pdfking/renderer-api"

import type { CalendarArea, CalendarBoxes } from "#internal"

import { Area } from "./Area"
import { CaptionText } from "./CaptionText"

/** A cover all picture, the year on it, the picture clear round it, `size` of the short
 * side tall, `at` a share of the security frame up from its foot, set as
 * `align` has it, or upwards along its left edge when `vertical`. */
export const PictureCover =
  ({
    align = HorizontalAlign.CENTER,
    at = 0.2,
    size = 0.14,
    vertical = false,
  }: {
    align?: HorizontalAlign
    at?: number
    size?: number
    vertical?: boolean
  }) =>
  ({ outer, page, short, year }: CalendarBoxes): CalendarArea[] => {
    const height: Distance = Scale(short, size)
    const caption = vertical
      ? { ...outer, width: height }
      : { ...outer, height, y: Total(outer.y, Scale(Subtract(outer.height, height), at)) }
    return [
      Area.picture(page, "cover", false, CaptionText(caption, `${year}`, align, vertical), true),
    ]
  }
